module.exports = __webpack_public_path__ + "4368cea9d43c50ae1898bcdf422dfb10.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/1/Assets/4to8.png
// module id = 1318
// module chunks = 0